import React from 'react';
import useReactRouter from 'use-react-router';
import { RouteParams } from 'components/custom-route/custom-route';
import { AntiFraudContext } from '../context/antifraud-context';

const useAntiFraudConsumer = () => {
    const { match: { params: { loanApplicationId } } } = useReactRouter<RouteParams>();
    const { antiFraud, borrowerPosition, refetch } = React.useContext(AntiFraudContext);

    return {
        antiFraud,
        borrowerPosition,
        refetch: () => refetch({ loanApplicationId }),
    };
};

export default useAntiFraudConsumer;
